<template>
  <div>
    <div class="row" v-if="!panel.id && editing === 'Generic'">
      <div class="col-xs-12">
        <h3>New Panel</h3>
        <div class="form-group mar-t30">
          <label for>Panel Type</label>
          <select v-model="panel.type" @change="panel.statDefinitionId = undefined">
            <option value="">-- Select Panel --</option>
            <option v-for="(option, index) in types" :value="option.value" :key="index">{{option.label}}</option>
          </select>
        </div>
      </div>
    </div>
    <div class="row" v-if="panel.type && editing === 'Generic' && selectDefintions[panel.type] && selectDefintions[panel.type].length">
      <div class="col-xs-12">
        <div class="form-group">
          <label for>Statistic</label>
          <select v-model="panel.statDefinitionId" @change="ev => statDefinition = definitions.find(d => d.id == ev.target.value)">
            <option :value="undefined">-- Select Stat --</option>
            <option v-for="(option, index) in selectDefintions[panel.type]" :key="index" :value="option.value">{{option.label}}</option>
          </select>
        </div>
      </div>
    </div>
    <div class="row" v-if="panel.type === 'timepanel'">
      <div class="col-xs-12">
        <div class="form-group">
          <label for>Timezone</label>
          <select v-model="panel.timezone">
            <option v-for="(option, index) in timezones" :key="index" :value="option">{{option}}</option>
          </select>
        </div>
      </div>
    </div>
    <component :is="editing" :panel="panel" v-if="panel.statDefinitionId || panel.type === 'timepanel'" :definition="statDefinition"></component>
    <div class="row mar-b15">
      <div class="col-xs-12">
        <div class="h-bar"></div>
      </div>
    </div>
    <div class="row" v-if="statSelected">
      <div class="col-xs-12 end-xs">
        <ul class="btn-list">
          <li v-if="editing === 'Generic' && statHasFilters"><button class="iv-btn warning" @click="render('Filters','')">Filters</button></li>
          <li v-if="editing === 'Generic'"><button class="iv-btn warning" @click="render('Alarms','900px')">Alarms</button></li>
          <li v-if="editing !== 'Generic'"><button class="iv-btn grey" @click="render('Generic','')">Back</button></li>
        </ul>
      </div>
    </div>
    <div class="row mar-t30" v-if="editing === 'Generic'">
      <div class="col-xs-12 end-xs">
        <ul class="btn-list">
          <li><button class="iv-btn grey" @click="cancel">Cancel</button></li>
          <li><button class="iv-btn" :disabled="!statSelected" @click="finish">Save</button></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../../../utils/axios";
import colours from "../../../utils/colours";
import Generic from "./Generic";
import Alarms from "./Alarms";
import Filters from "./Filters";

import moment from "moment-timezone";

export default {
  props: ["cancel", "save", "panel", "setWidth", "definitions"],
  components: { Generic, Alarms, Filters },
  data() {
    return {
      openDrawer: false,
      types: [{ label: "Statistic", value: "stat" }, { label: "Graph", value: "graph" }, { label: "List", value: "list" }, { label: "Time", value: "timepanel" }],
      selectDefintions: {},
      statDefinition: undefined,
      editing: "Generic",
      timezones: moment.tz.names()
    };
  },
  computed: {
    statSelected() {
      return this.panel && this.panel.type && (this.panel.statDefinitionId || this.panel.type === 'timepanel')
    },
    statHasFilters() {
      return this.statDefinition && this.statDefinition.filters && this.statDefinition.filters.length
    }
  },
  created() {
    let types = {};
    this.definitions.forEach(definition => {
      if (!types[definition.panelType]) types[definition.panelType] = [];
      types[definition.panelType].push({ label: definition.name, value: definition.id });
    });
    Object.keys(types).forEach(type => {
      types[type].sort((a, b) => {
        let textA = a.label.toUpperCase();
        let textB = b.label.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
    });

    this.selectDefintions = types;

    if (this.panel.statDefinitionId) {
      this.statDefinition = this.definitions.find(d => d.id === this.panel.statDefinitionId) || {};
    }
  },
  watch: {
    statDefinition: function(val, prev) {
      if (val) {
        if (!this.panel.title.text) this.panel.title.text = val.name;
        if (prev && this.panel.title.text === prev.name) this.panel.title.text = val.name;
      }
    },
    "panel.type": function(val) {
      if (val === "timepanel" && !this.panel.timezone) {
        this.panel.timezone = moment.tz.guess();
      }
    }
  },
  methods: {
    finish() {
      this.panel.statDefinitionId = this.statDefinition ? this.statDefinition.id : undefined;
      if (!this.panel.id) {
        switch (this.panel.type) {
          case "stat":
          case "timepanel":
            this.panel.width = 3;
            this.panel.height = 3;
            break;
          case "graph":
            this.panel.height = 4;
            this.panel.width = 4;
            break;
          case "list":
            this.panel.height = 4;
            this.panel.width = 5;
            break;
        }
      }
      this.save(this.panel);
    },
    render(type, width) {
      this.editing = type;
      this.setWidth(width);
    }
  }
};
</script>
